import script from "./AppOpenStreetMapAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./AppOpenStreetMapAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./AppOpenStreetMapAutocomplete.vue?vue&type=style&index=0&id=2bf6f0bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf6f0bc"]])

export default __exports__